module.exports = __webpack_public_path__ + "static/media/paperCardHeader.23c164ac.svg";